import {Injectable} from '@angular/core';
import {AuthService, UsersService} from '@hassel-it/angular-common';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {

    public permissions: any = {};

    features = [{key: 'driver_edit', userIds: [1, 17]}];

    constructor(public authService: AuthService,
                public usersService: UsersService,
    ) {
    }

    public buildPermissions() {
       return this.usersService.getCurrentUser(true).then(user => {
            user?.permissions.forEach(permission => {
                this.permissions[permission.aco.alias] = permission.allowed;
            })
            return Promise.resolve(true);
        });
    }
}
